import AutoNumbering from "./AutoNumbering/AutoNumbering";
// import AtriaUserRole from "../Common/Role/AtriaUserRole";
import React from "react";
class AutoNumberingDetails extends React.Component {
  constructor() {
    super();

    this.state = {
      activeMenu: "Auto Numbering"
    };

    this.changeMenu = this.changeMenu.bind(this);
  }

  changeMenu(e, menu) {
    e.preventDefault();

    this.setState({ activeMenu: menu });
  }

  render() {
    const { activeMenu } = this.state;
    const user = this.props.user;
    return (
      <div className="tab-style-1">
        <div
          className="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            className={
              activeMenu === "Auto Numbering" ? "nav-link active" : "nav-link"
            }
            id="specs-tab"
            data-toggle="pill"
            href="#specs"
            role="tab"
            aria-controls="specs"
            aria-selected="true"
            onClick={e => {
              this.changeMenu(e, "Auto Numbering");
            }}
          >
            Auto Numbering
          </a>
          {/* <a
            className={activeMenu === "BOM" ? "nav-link active" : "nav-link"}
            id="bom-tab"
            data-toggle="pill"
            href="#bom"
            role="tab"
            aria-controls="bom"
            aria-selected="false"
            onClick={e => {
              this.changeMenu(e, "BOM");
            }}
          >
            Role
          </a> */}
        </div>

        <div className="tab-content" id="v-pills-tabContent">
          {activeMenu === "Auto Numbering" && user.Id ? (
            <AutoNumbering user={user} />
          ) : null}

          {/* {activeMenu === "BOM" ? (
            <AtriaUserRole 
              userId={userId} 
              user={user} 
            />
          ) : null} */}
        </div>
      </div>
    );
  }
}

export default AutoNumberingDetails;
